import React, { useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import FeatherIcon from 'feather-icons-react';
import { Modal, Form, Select, Row, message, Table, Skeleton } from 'antd';
import { BasicFormWrapper } from '../../styled';
import { getQueryFieldsByType, getAllRelatedEntity } from '../../../Api/Services/ViewApiService'
import { Button } from '../../../components/buttons/buttons';

const Popup = ({ showPopup, setShowPopup, callBack, selectedEntity }) => {

    const { Option } = Select;
    const [form] = Form.useForm();
    const [queryData, setqueryData] = useState([]);
    const handleClose = () => {
        setShowPopup(false);
    }
    const getQueryFields = async (entity) => {
        try {
            const response = await getQueryFieldsByType(entity, "Template")
            return response.data
        } catch (error) {
            message.error(error)
            return []
        }
    }
    const getEntity = async (Entity) => {
        try {
            const response = await getAllRelatedEntity(Entity, "Template")
            return response
        } catch (error) {
            message.error(error)
            return []
        }
    }
    const formatResponseForBackend = (response) => {
        if (response.length === 1) {
            const { entity, attribute } = response[0];
            return `{{${entity}.${attribute}}}`;
        }
        if (response.length > 1) {
            const entities = response.map(item => item.entity);
            const attribute = response[response.length - 1].attribute || '';

            return `{{${entities.join('.')}.${attribute}}}`;
        }
        return '';
    };
    const onSubmit = async () => {
        const Insert = formatResponseForBackend(queryData)
        callBack(Insert)
        setShowPopup(false);
    }
    const onFinishFailed = () => {
        message.error("Please fill out all required fields")
    }
    // const handleViewChange = async (index, fieldName, value) => {
    //     const updatedFormData = [...queryData];
    //     updatedFormData[index] = {
    //         ...updatedFormData[index],
    //         [fieldName]: value,
    //     };
    //     if (fieldName === 'entity') {
    //         const entity = value;
    //         const attributeOptions = await getQueryFields(entity);
    //         updatedFormData[index] = {
    //             ...updatedFormData[index],
    //             attributeOption: attributeOptions,
    //             attribute: null
    //         };
    //         const nextIndex = index + 1;
    //         if (nextIndex < updatedFormData.length) {
    //             const nextEntityOptions = await getEntity(entity);
    //             updatedFormData[nextIndex] = {
    //                 ...updatedFormData[nextIndex],
    //                 entityOptions: nextEntityOptions
    //             };
    //         }
    //     }
    //     setqueryData(updatedFormData);
    // };
    const handleViewChange = async (index, fieldName, value) => {
        const newFormData = [...queryData];
        newFormData[index] = {
            ...newFormData[index],
            [fieldName]: value,
        };
        if (fieldName === 'entity') {
            const entity = value;
            const attributeOptions = await getQueryFields(entity);
            const nextIndex = index + 1;
            let nextEntityOptions = [];
            if (nextIndex < newFormData.length) {
                nextEntityOptions = await getEntity(entity);
            }
            newFormData[index] = {
                ...newFormData[index],
                attributeOption: attributeOptions,
                attribute: null,
            };
            if (nextIndex < newFormData.length) {
                newFormData[nextIndex] = {
                    ...newFormData[nextIndex],
                    entityOptions: nextEntityOptions,
                };
            }
        }
        setqueryData(newFormData);
    };

    const handleRemoveQuery = (index) => {
        const updatedQueries = [...queryData];
        updatedQueries.splice(index, 1);

        if (index === updatedQueries.length && index > 0) {
            const previousIndex = index - 1;
            updatedQueries[previousIndex] = {
                ...updatedQueries[previousIndex],
                disabled: false,
            };
        }
        if (updatedQueries.length === 1 && 'NextQuery' in updatedQueries[0]) {
            const { NextQuery, ...rest } = updatedQueries[0];
            setqueryData([rest]);
        } else {
            setqueryData(updatedQueries);
        }
    }
    async function getEntityTypes(Entity) {
        try {
            const response = await getAllRelatedEntity("All", "Template")
            const AttributeData = await getQueryFields(Entity)
            setqueryData([
                {
                    entityOptions: response,
                    entity: Entity,
                    attribute: null,
                    attributeOption: AttributeData,
                },
                ...queryData.slice(1)
            ])
        } catch (error) {
            message.error(error)
            setqueryData([
                {
                    entityOptions: [],
                    entity: Entity,
                    attribute: null,
                    attributeOption: [],
                },
                ...queryData.slice(1)
            ])
        }
    }
    useEffect(() => {
        if (showPopup && selectedEntity) {
            getEntityTypes(selectedEntity)
        }
    }, [selectedEntity, showPopup]);
    const columns = [
        {
            title: '',
            dataIndex: 'NextQuery',
            key: 'NextQuery',
            render: (text, record) =>
                record.NextQuery && (
                    <Form.Item>
                        <span>Relates to</span>
                    </Form.Item>
                ),
        },
        {
            title: '',
            dataIndex: 'entity',
            key: 'entity',
            render: (text, record, index) => (
                <Form.Item>
                    <Select placeholder="Select Module"
                        disabled={index === 0}
                        style={{ width: "100%" }}
                        showSinputearch
                        optionFilterProp="children"
                        filterOption={(input, option) =>
                            option.children.toLowerCase().indexOf(input.toLowerCase()) >= 0
                        }
                        name="entity"
                        value={record && record.entity}
                        onChange={(record) => {
                            handleViewChange(index, 'entity', record);
                        }}
                    >
                        {record.entityOptions && record.entityOptions.map((option, index) => (
                            <Option value={option.entity} key={index}>
                                {option.entity}
                            </Option>))}
                    </Select>
                </ Form.Item>
            ),
        },
        {
            title: '',
            dataIndex: 'attribute',
            key: 'attribute',
            render: (text, record, index) => (
                <Form.Item>
                    <Select placeholder="Select Attribute"
                        showSearch style={{ width: "100%" }}
                        optionFilterProp="children"
                        filterOption={(input, option) =>
                            option.children.toLowerCase().indexOf(input.toLowerCase()) >= 0
                        }
                        name="attribute"
                        disabled={record.disabled}
                        value={record.attribute}
                        onChange={(value) => {
                            handleViewChange(index, 'attribute', value);
                        }}
                    >
                        {record.attributeOption && record.attributeOption.map((option, index) => (
                            <Option value={option.filedValue} key={index}>
                                {option.fieldLable}
                            </Option>))}
                    </Select>
                </Form.Item>
            ),
        },
        {
            title: '',
            dataIndex: 'action',
            key: 'action',
            render: (text, record, index) => {
                if (index > 0 && queryData.length > 1) {
                    return (
                        <FeatherIcon icon="trash-2" size={20} style={{ margin: "10px 0px 0px 0px" }} className="fetcherDelete-Icon"
                            onClick={() => handleRemoveQuery(index)} />
                    );
                }
            },
        }
    ];
    const handleAddQuery = async () => {
        const updatedFormData = [...queryData];
        const lastIndex = updatedFormData.length - 1;
        const previousEntity = updatedFormData[lastIndex]?.entity;
        const entityOption = await getEntity(previousEntity);
        updatedFormData.push({
            entityOptions: entityOption,
            entity: null,
            attribute: null,
            disabled: false,
            NextQuery: true,
        });
        updatedFormData[lastIndex] = {
            ...updatedFormData[lastIndex],
            attribute: null, // Remove attribute value
            disabled: true, // Disable the attribute field
        };

        setqueryData(updatedFormData);
    };
    return (
        <>
            <Modal
                title="Template Query"
                open={showPopup}
                onCancel={handleClose}
                maskClosable={false}
                width={800}
                footer={queryData?.length > 0 ? [
                    <div>
                        <Button
                            size="small"
                            className="gray-button"
                            onClick={handleClose}
                        >
                            <FeatherIcon icon="x" />  Cancel
                        </Button>

                        <Button size="small" onClick={onSubmit} className="button_colors" >
                            <FeatherIcon icon="log-in" /> Insert
                        </Button>

                    </div>
                ] : false}
            >
                <div className="user-info-form" style={{ padding: "0px 20px" }}>
                    <BasicFormWrapper>
                        <Form style={{ width: '100%' }} form={form} name="info" colon={false}
                            onFinishFailed={onFinishFailed} >
                            {queryData?.length > 0 ? <>
                                <div className='cxsquare-create-view'>
                                    <Table
                                        dataSource={queryData}
                                        columns={columns}
                                        rowKey={(record, index) => index.toString()}
                                        pagination={false}
                                    />
                                </div>
                                {queryData[queryData.length - 1]?.entity === "Users" ? <></> :
                                    <Row style={{ marginTop: 15 }}>
                                        <Button className="button_colors" size="small" onClick={handleAddQuery}
                                            disabled={
                                                queryData[queryData.length - 1]?.entity === null
                                            }
                                        >
                                            <FeatherIcon icon="plus-circle" /> Realtes to
                                        </Button>
                                    </Row>}</>
                                : <Skeleton active />}
                        </Form>
                    </BasicFormWrapper >
                </div >
            </Modal >
        </>
    );
};

Popup.propTypes = {
    showPopup: PropTypes.bool.isRequired,
    setShowPopup: PropTypes.func.isRequired,
    callBack: PropTypes.func.isRequired,
    selectedEntity: PropTypes.string.isRequired,
};

export default Popup;
